import { useLocation, useNavigate } from 'react-router-dom'
import { useEffect, useState } from 'react'

//Components
import Loader from '../components/loader'
import Menu from '../components/menu'
import Snack from '../components/snack'

//Extras
import { fontType, main } from '../assets/extras'
import { addDoc, collection, doc, getDocs, updateDoc } from 'firebase/firestore'
import { db } from '../assets/connections'

const Sedes = () => {

    const navigate = useNavigate()

    const location = useLocation()
    const ref = location.state ? location.state.ref : null
    const academia = location.state ? location.state.academia : null

    const [variables, setVariables] = useState({
        loading: true,
        sedes: [],
        stats: {},
        showForm: false,
        editingSede: null,
        form: {
            nombre_sede: "",
            direccion_sede: "",
            telefono_sede: "",
            numero_canchas: 0,
            latitud: "",
            longitud: "",
            activa_clases_muestra: true,
            activa: true
        }
    })

    const showMessage = (message, status) => {
        let contSnack = document.getElementById("contSnack")
        let snack = document.createElement("div")
        snack.classList.add("snack")
        snack.innerHTML = status === "warning" ?
            "<i class='fa-solid fa-triangle-exclamation fa-beat' style='color: #f9b92f;'></i>" +
            "<p style='font-family:" + fontType.text + ";'>" + message + "</p>" +
            "<div className='snackBar' style='background-color: #f9b92f;'></div>"
          : ""
        contSnack.appendChild(snack)
        setTimeout(() => { snack.remove() }, 5000)
    }

    const getData = async () => {
        try {
            const refDoc = doc(db, ref)

            // Cargar sedes
            const sedesSnap = await getDocs(collection(refDoc, "Sedes"))
            const sedesAux = sedesSnap.docs.map(v => ({ id: v.id, ...v.data() }))

            // Cargar estadisticas por sede
            const clasesSnap = await getDocs(collection(refDoc, "Clases"))
            const jugadoresSnap = await getDocs(collection(refDoc, "Jugador"))

            var stats = {}
            sedesAux.forEach(s => {
                stats[s.id] = { clases: 0, jugadores: 0 }
            })

            const sedeDefaultId = sedesAux.find(s => s.es_default)?.id || sedesAux[0]?.id || ""

            clasesSnap.docs.forEach(v => {
                if(v.id.split("-").length === 1) {
                    const d = v.data()
                    const classSedes = d.sedes && d.sedes.length > 0
                        ? d.sedes
                        : (d.sede ? [d.sede] : [sedeDefaultId])
                    classSedes.forEach(sedeId => {
                        if(stats[sedeId]) {
                            stats[sedeId].clases++
                        }
                    })
                }
            })

            jugadoresSnap.docs.forEach(v => {
                const sedeId = v.data().sede_default || sedeDefaultId
                if(stats[sedeId]) {
                    stats[sedeId].jugadores++
                }
            })

            setVariables(prev => ({
                ...prev,
                sedes: sedesAux,
                stats,
                loading: false
            }))
        } catch(e) {
            console.log(e)
            setVariables(prev => ({ ...prev, loading: false }))
        }
    }

    const toggleField = async (sedeId, field, currentValue) => {
        // Si está desactivando, verificar que no tenga datos
        if (field === "activa" && currentValue === true) {
            const stats = variables.stats[sedeId]
            if (stats && (stats.clases > 0 || stats.jugadores > 0)) {
                showMessage("No se puede desactivar: tiene " + stats.clases + " clases y " + stats.jugadores + " jugadores", "warning")
                return
            }
        }
        try {
            await updateDoc(doc(db, ref, "Sedes", sedeId), {
                [field]: !currentValue
            })
            setVariables(prev => ({
                ...prev,
                sedes: prev.sedes.map(s =>
                    s.id === sedeId ? { ...s, [field]: !currentValue } : s
                )
            }))
        } catch(e) {
            console.log(e)
        }
    }

    const resetForm = () => {
        setVariables(prev => ({
            ...prev,
            showForm: false,
            editingSede: null,
            form: {
                nombre_sede: "",
                direccion_sede: "",
                telefono_sede: "",
                numero_canchas: 0,
                latitud: "",
                longitud: "",
                activa_clases_muestra: true,
                activa: true
            }
        }))
    }

    const saveSede = async () => {
        if(!variables.form.nombre_sede || !variables.form.direccion_sede) return

        setVariables(prev => ({ ...prev, loading: true }))

        try {
            const lat = parseFloat(variables.form.latitud)
            const lng = parseFloat(variables.form.longitud)
            const coordenadas = (!isNaN(lat) && !isNaN(lng)) ? { lat, lng } : null

            if(variables.editingSede) {
                await updateDoc(doc(db, ref, "Sedes", variables.editingSede), {
                    nombre_sede: variables.form.nombre_sede,
                    direccion_sede: variables.form.direccion_sede,
                    telefono_sede: variables.form.telefono_sede,
                    numero_canchas: parseInt(variables.form.numero_canchas) || 0,
                    coordenadas: coordenadas,
                    activa_clases_muestra: variables.form.activa_clases_muestra,
                    activa: variables.form.activa
                })
            } else {
                const { latitud, longitud, ...formWithoutCoords } = variables.form
                await addDoc(collection(doc(db, ref), "Sedes"), {
                    ...formWithoutCoords,
                    numero_canchas: parseInt(variables.form.numero_canchas) || 0,
                    coordenadas: coordenadas,
                    es_default: variables.sedes.length === 0,
                    creado_en: new Date()
                })
            }
            resetForm()
            await getData()
        } catch(e) {
            console.log(e)
            setVariables(prev => ({ ...prev, loading: false }))
        }
    }

    const editSede = (sede) => {
        setVariables(prev => ({
            ...prev,
            showForm: true,
            editingSede: sede.id,
            form: {
                nombre_sede: sede.nombre_sede || "",
                direccion_sede: sede.direccion_sede || "",
                telefono_sede: sede.telefono_sede || "",
                numero_canchas: sede.numero_canchas || 0,
                latitud: sede.coordenadas?.lat != null ? String(sede.coordenadas.lat) : "",
                longitud: sede.coordenadas?.lng != null ? String(sede.coordenadas.lng) : "",
                activa_clases_muestra: sede.activa_clases_muestra !== false,
                activa: sede.activa !== false
            }
        }))
    }

    useEffect(() => {
        if(!sessionStorage.getItem("homeFlag") || !ref){
            navigate("/home", { replace: true })
        } else {
            getData()
        }
    }, [])

    if(variables.loading)
        return <Loader loading={variables.loading} />

    return (
        <div style={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            paddingBottom: 50
        }}>
            <Snack />
            <h2 style={{
                backgroundColor: main,
                fontFamily: fontType.title,
                paddingBottom: 0,
                width: "100%",
                textAlign: "center",
                color: "white",
                padding: 20,
                margin: 0
            }}>SEDES</h2>
            <h2 style={{
                backgroundColor: main,
                fontFamily: fontType.text,
                marginTop: -20,
                marginBottom: 40,
                fontSize: 18,
                padding: 10,
                paddingTop: 0,
                width: "100%",
                textAlign: "center",
                color: "white"
            }}>{
                localStorage.getItem("authToken") ?
                    JSON.parse(localStorage.getItem("authToken")).nombre_academia
                : ""
            }</h2>

            <Menu
                academia={academia}
                reference={ref}
            />

            <button
                style={{
                    backgroundColor: main,
                    color: "white",
                    fontFamily: fontType.subTitle,
                    fontSize: 16,
                    padding: "12px 30px",
                    borderRadius: 10,
                    border: "none",
                    cursor: "pointer",
                    marginBottom: 30
                }}
                onClick={() => setVariables(prev => ({ ...prev, showForm: true, editingSede: null }))}
            >
                AGREGAR SEDE
            </button>

            {/* Formulario */}
            {variables.showForm && (
                <div style={{
                    width: "90%",
                    maxWidth: 500,
                    border: "2px solid " + main,
                    borderRadius: 10,
                    padding: 20,
                    marginBottom: 30,
                    display: "flex",
                    flexDirection: "column",
                    gap: 10
                }}>
                    <p style={{ fontFamily: fontType.title, fontSize: 18, textAlign: "center" }}>
                        {variables.editingSede ? "EDITAR SEDE" : "NUEVA SEDE"}
                    </p>
                    <input
                        placeholder="Nombre de la sede"
                        value={variables.form.nombre_sede}
                        onChange={e => setVariables(prev => ({ ...prev, form: { ...prev.form, nombre_sede: e.target.value }}))}
                        style={styles.input}
                    />
                    <input
                        placeholder="Direccion"
                        value={variables.form.direccion_sede}
                        onChange={e => setVariables(prev => ({ ...prev, form: { ...prev.form, direccion_sede: e.target.value }}))}
                        style={styles.input}
                    />
                    <input
                        placeholder="Telefono"
                        value={variables.form.telefono_sede}
                        onChange={e => setVariables(prev => ({ ...prev, form: { ...prev.form, telefono_sede: e.target.value }}))}
                        style={styles.input}
                    />
                    <label style={{ fontFamily: fontType.text, fontSize: 14, color: "#555" }}>Numero de canchas</label>
                    <input
                        type="number"
                        placeholder="0"
                        value={variables.form.numero_canchas}
                        onChange={e => setVariables(prev => ({ ...prev, form: { ...prev.form, numero_canchas: e.target.value }}))}
                        style={styles.input}
                    />
                    <label style={{ fontFamily: fontType.text, fontSize: 14, color: "#555", marginTop: 5 }}>Coordenadas (opcional)</label>
                    <div style={{ display: "flex", gap: 10, width: "100%" }}>
                        <input
                            type="number"
                            step="any"
                            placeholder="Latitud (ej: 20.67194)"
                            value={variables.form.latitud}
                            onChange={e => setVariables(prev => ({ ...prev, form: { ...prev.form, latitud: e.target.value }}))}
                            style={{ ...styles.input, flex: 1 }}
                        />
                        <input
                            type="number"
                            step="any"
                            placeholder="Longitud (ej: -103.33813)"
                            value={variables.form.longitud}
                            onChange={e => setVariables(prev => ({ ...prev, form: { ...prev.form, longitud: e.target.value }}))}
                            style={{ ...styles.input, flex: 1 }}
                        />
                    </div>
                    <button
                        onClick={() => {
                            const addr = variables.form.direccion_sede
                            if (addr) {
                                window.open(`https://www.google.com/maps/search/${encodeURIComponent(addr)}`, "_blank")
                            }
                        }}
                        style={{ padding: "6px 14px", cursor: "pointer", fontFamily: fontType.text, fontSize: 12, border: "1px solid #aaa", borderRadius: 6, background: "white", color: "#333", alignSelf: "flex-start" }}
                    >
                        Buscar en Google Maps
                    </button>
                    <label style={{ fontFamily: fontType.text, display: "flex", alignItems: "center", gap: 8 }}>
                        <input
                            type="checkbox"
                            checked={variables.form.activa}
                            onChange={e => setVariables(prev => ({ ...prev, form: { ...prev.form, activa: e.target.checked }}))}
                        />
                        Sede activa
                    </label>
                    <label style={{ fontFamily: fontType.text, display: "flex", alignItems: "center", gap: 8 }}>
                        <input
                            type="checkbox"
                            checked={variables.form.activa_clases_muestra}
                            onChange={e => setVariables(prev => ({ ...prev, form: { ...prev.form, activa_clases_muestra: e.target.checked }}))}
                        />
                        Clases muestra activas
                    </label>
                    <div style={{ display: "flex", gap: 10, justifyContent: "center", marginTop: 10 }}>
                        <button onClick={resetForm} style={{ padding: "8px 20px", cursor: "pointer", fontFamily: fontType.subTitle, background: "none", border: "1px solid #aaa", borderRadius: 8 }}>
                            CANCELAR
                        </button>
                        <button onClick={saveSede} style={{ padding: "8px 20px", cursor: "pointer", fontFamily: fontType.subTitle, backgroundColor: main, color: "white", border: "none", borderRadius: 8 }}>
                            GUARDAR
                        </button>
                    </div>
                </div>
            )}

            {/* Lista de sedes */}
            <div style={{ width: "90%", maxWidth: 700 }}>
                {variables.sedes.map(sede => {
                    const stat = variables.stats[sede.id] || { clases: 0, jugadores: 0 }
                    return (
                        <div key={sede.id} style={{
                            border: "2px solid " + (sede.activa !== false ? main : "#ccc"),
                            borderRadius: 10,
                            padding: 15,
                            marginBottom: 15,
                            opacity: sede.activa !== false ? 1 : 0.6
                        }}>
                            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                <div>
                                    <p style={{ fontFamily: fontType.subTitle, fontSize: 18, margin: 0 }}>
                                        {sede.nombre_sede}
                                        {sede.es_default && <span style={{ fontSize: 12, color: "#888", marginLeft: 8 }}>(Principal)</span>}
                                    </p>
                                    <p style={{ fontFamily: fontType.text, fontSize: 14, color: "#666", margin: "4px 0" }}>
                                        {sede.direccion_sede}
                                    </p>
                                </div>
                                <button
                                    onClick={() => editSede(sede)}
                                    style={{ padding: "6px 14px", cursor: "pointer", fontFamily: fontType.text, border: "1px solid " + main, borderRadius: 6, background: "white", color: main }}
                                >
                                    Editar
                                </button>
                            </div>

                            <div style={{ display: "flex", gap: 20, marginTop: 10, fontFamily: fontType.text, fontSize: 14 }}>
                                <span>Clases: <b>{stat.clases}</b></span>
                                <span>Jugadores: <b>{stat.jugadores}</b></span>
                                {sede.numero_canchas > 0 && <span>Canchas: <b>{sede.numero_canchas}</b></span>}
                                {sede.telefono_sede && <span>Tel: {sede.telefono_sede}</span>}
                            </div>

                            <div style={{ display: "flex", gap: 15, marginTop: 10 }}>
                                <label style={{ fontFamily: fontType.text, fontSize: 13, display: "flex", alignItems: "center", gap: 5, cursor: "pointer" }}>
                                    <input
                                        type="checkbox"
                                        checked={sede.activa !== false}
                                        onChange={() => toggleField(sede.id, "activa", sede.activa !== false)}
                                    />
                                    Activa
                                </label>
                                <label style={{ fontFamily: fontType.text, fontSize: 13, display: "flex", alignItems: "center", gap: 5, cursor: "pointer" }}>
                                    <input
                                        type="checkbox"
                                        checked={sede.activa_clases_muestra !== false}
                                        onChange={() => toggleField(sede.id, "activa_clases_muestra", sede.activa_clases_muestra !== false)}
                                    />
                                    Clases muestra
                                </label>
                            </div>
                        </div>
                    )
                })}

                {variables.sedes.length === 0 && (
                    <p style={{ textAlign: "center", fontFamily: fontType.text, color: "#888" }}>
                        No hay sedes configuradas
                    </p>
                )}
            </div>
        </div>
    )
}

const styles = {
    input: {
        padding: 10,
        borderRadius: 8,
        border: "1px solid #ccc",
        fontSize: 14,
        width: "100%",
        boxSizing: "border-box"
    }
}

export default Sedes
